import { render, staticRenderFns } from "./checkbox-widget.vue?vue&type=template&id=608e81d3&scoped=true&"
import script from "./checkbox-widget.vue?vue&type=script&lang=js&"
export * from "./checkbox-widget.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-widget.vue?vue&type=style&index=0&id=608e81d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e81d3",
  null
  
)

export default component.exports